<template>
    <auth-box class="max-w-[420px]"
        :errors="props.errors">
        <form @submit="submitting = true"
            id="mfa-form"
            data-test="mfa-form"
            method="POST"
            action="/login/token"
            class="flex flex-col gap-4">

            <input name="token"
                :value="token"
                type="hidden">

            <div>
                <div class="text-base font-bold">2 Factor Code</div>
                <div class="text-sm text-slate-500">
                    Six-digit code from your authenticator app.
                </div>

            </div>
            <div>
                <code-input v-model="token" ref="inputRef" :error="displayFirstError(v$.token.$errors)"></code-input>
                <a class="flex mt-2 items-center underline text-slate-600 hover:text-slate-600 text-xs"
                    :href="`/login-via-emergency-token`">
                    Trouble with your code?
                </a>
            </div>

            <div class="flex flex-col gap-2 mt-4 md:flex-row-reverse">
                <vx-button :loading="submitting"
                    class="md:grow"
                    @click.prevent="submit"
                    data-test="submit"
                    color="primary"
                    size="lg">
                    Verify <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
                </vx-button>

                <vx-button color="muted"
                    size="lg"
                    href="/login">
                    Cancel
                </vx-button>
            </div>
        </form>
    </auth-box>
</template>
<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AuthBox from '../AuthBox.vue';
import { VxButton } from '@voxie/frontend-components';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { nextTick, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, numeric, required } from '@vuelidate/validators';
import { displayFirstError } from '~/utils/validation';
import CodeInput from '~/components/general/CodeInput.vue';

const props = defineProps({
    errors: Array,
});

const submitting = ref(false);

const inputRef = ref();

onMounted(async () => {
    await nextTick();
    inputRef.value.inputs[0].field.focus();
})

const token = ref(null);

const v$ = useVuelidate({
    token: {
        required, numeric, length: helpers.withMessage('The code must be 6 characters length', (value) => 6 === value?.length),
    }
}, { token });

const submit = async () => {
    submitting.value = true;

    const isFormCorrect = await v$.value.$validate();
    if (!isFormCorrect) {
        submitting.value = false;
        return;
    }

    window.document.getElementById('mfa-form').submit();
};
</script>
